import { PCFShadowMap, SRGBColorSpace, WebGLRenderer } from "three"
import { getDeviceUserPreference } from "../../../rx/shared/device/userPreference/deviceUserPreferencesSignal"

export default function createMainRenderer(
  canvasElem: HTMLCanvasElement | OffscreenCanvas,
) {
  const prefs = getDeviceUserPreference()

  const renderer = new WebGLRenderer({
    // alpha: true,
    canvas: canvasElem,
    antialias: prefs.antialias,
    // powerPreference: "high-performance", "low-power", "default",
    powerPreference: prefs.powerPreference,
    // default is false, which is faster
    // preserveDrawingBuffer: true,

    // this settings reduces tearing between polygon edges.
    logarithmicDepthBuffer: true,
  })

  renderer.setSize(canvasElem.width, canvasElem.height)

  // renderer.outputEncoding = THREE.sRGBEncoding
  // renderer.toneMapping = THREE.ACESFilmicToneMapping

  renderer.shadowMap.enabled = true

  // BasicShadowMap = lowest quality & fastest
  // PCFShadowMap = softens edges slightly
  // PCFSoftShadowMap = slower, not recommended for retro look
  // renderer.shadowMap.type = VSMShadowMap
  renderer.shadowMap.type = PCFShadowMap

  // renderer.toneMapping = ACESFilmicToneMapping
  // renderer.toneMappingExposure = 0.5
  renderer.outputColorSpace = SRGBColorSpace

  return renderer
}